// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';

import { UI_STRINGS } from '../../../functions/language/uistrings';
import { Language } from '../../../model/enums/language';
import { LanguageService } from '../../../services/language.service';
import { TranslationService } from '../../../services/translation-service';

@Pipe({
    name: 'translateParameter',
    pure: true,
    standalone: false
})
export class TranslateParameterPipe implements PipeTransform {
  readonly VARIABLE_TITLE = UI_STRINGS.MODEL.VARIABLE_TITLE;
  constructor(private _languageService: LanguageService, private _translationService: TranslationService) {}
  transform(value: string, language?: Language): string {
    if (!language) {
      language = this._languageService.language;
    }
    return this._translationService.translate(language, this.VARIABLE_TITLE[value?.toUpperCase()]);
  }
}
